import { graphql } from "relay-runtime"

export const chDuplicatePatientChangedSubscription = graphql`
  subscription useChDuplicatePatientChangedSubscription {
    ch_patientChanged {
      id
      firstName
      lastName
      gender
      displayId
      contactChannel
      country
    }
  }
`
